export const isExternalLink = (url: string) => {
    if(/(http(s?)):\/\//i.test(url)) {
        return true;
    }
    return false;
};
